module.exports = __webpack_public_path__ + "static/media/background-client-table.9c4de3e3.jpg";